import { Auth0Provider } from "@auth0/auth0-react";
import { Capacitor } from "@capacitor/core";
import type { ReactNode } from "react";
import capacitorConfig from "../../capacitor.config";

interface AuthProviderProps {
	children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
	const isNative = Capacitor.isNativePlatform();

	// Dynamically construct the Auth0 mobile redirect URI
	// Format: YOUR_PACKAGE_ID://{yourDomain}/capacitor/YOUR_PACKAGE_ID/callback
	const auth0Domain = import.meta.env.VITE_AUTH0_DOMAIN;
	const packageId = capacitorConfig.appId; // co.eraborn.app

	// Use different client IDs for web (SPA) vs mobile (Native)
	const clientId = isNative
		? import.meta.env.VITE_AUTH0_NATIVE_CLIENT_ID ||
			import.meta.env.VITE_AUTH0_CLIENT_ID
		: import.meta.env.VITE_AUTH0_CLIENT_ID;

	// Use different redirect URIs for web vs mobile
	const redirectUri = isNative
		? `${packageId}://${auth0Domain}/capacitor/${packageId}/callback`
		: import.meta.env.VITE_AUTH0_REDIRECT_URI ||
			`${window.location.origin}/callback`;

	return (
		<Auth0Provider
			domain={auth0Domain}
			clientId={clientId}
			authorizationParams={{
				redirect_uri: redirectUri,
				...(import.meta.env.VITE_AUTH0_AUDIENCE
					? { audience: import.meta.env.VITE_AUTH0_AUDIENCE }
					: {}),
				scope: "openid profile email offline_access",
			}}
			cacheLocation="localstorage"
			useRefreshTokens={true}
			useRefreshTokensFallback={false}
		>
			{children}
		</Auth0Provider>
	);
}
